import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import styled from "styled-components";
import ReferralIcon from "../../../../resources/images/navigation/referral.svg";
import IntegrationsIcon from "../../../../resources/images/navigation/integrations.svg";
import SecurityIcon from "../../../../resources/images/navigation/security.svg";
import WhatsNewIcon from "../../../../resources/images/navigation/whats-new.svg";
import colors from "../../../../helpers/colors";
import { handleKeyPress } from "../../../../helpers/keyboardHelper";

const Icon = styled.div`
	height: 20px;
	width: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px 21px 0 20px;
`;

const AccordionItem = (props) => {
	const [opened, setOpened] = useState(false);

	const toggleOpen = () => {
		setOpened(!opened);
	};

	function createLinkElement(link) {
		return (
			<a href={link.href} style={{ textDecoration: "none" }} key={link.label}>
				<div
					className={"nav_accordion-item__container " + link.label}
					key={link.label}
				>
					<div className="nav_accordion-item__product navFlexRow">
						<div className="navFlexColumn">
							<Icon>
								<img
									src={link.image}
									alt={"Icon for " + link.label}
									width="19"
									key={link.label}
								/>
							</Icon>
						</div>

						<div className="navFlexColumn">
							<p className="nav_accordion-item__label">{link.label}</p>
							<p className="nav_accordion-item__description">
								{link.description}
							</p>
						</div>
					</div>
				</div>
			</a>
		);
	}

	function createCompanyElement(link) {
		return (
			<div className="related-column" key={link.label}>
				<a className="related-button" href={link.externalHref} key={link.label}>
					<img src={link.image} alt={"Icon for " + link.label} width="19" />
					<p className="related-text">{link.label}</p>
				</a>
			</div>
		);
	}

	function createResourceElement(link) {
		return (
			<div className="related-column" key={link.label}>
				<a className="related-button" href={link.href} key={link.label}>
					<img src={link.image} alt={"Icon for " + link.label} width="19" />
					<p className="related-text">{link.label}</p>
				</a>
			</div>
		);
	}

	const renderIcon = () => {
		if (opened) {
			return (
				<FontAwesomeIcon
					icon={faChevronUp}
					style={{ color: colors.mvDarkGrey }}
					alt="Arrow icon pointing up"
				/>
			);
		} else {
			return (
				<FontAwesomeIcon
					icon={faChevronRight}
					style={{ color: colors.mvDarkGrey }}
					alt="Arrow icon pointing right"
				/>
			);
		}
	};
    
	return (
		<>
			{props.data.links && (
				<div
					{...{
						className: `nav_accordion-item, ${
							opened && "nav_accordion-item--opened"
						}`,
					}}
					onClick={toggleOpen}
					key={props.data.title} // Unique key for the outer div
					onKeyDown={(event) => handleKeyPress(event, toggleOpen)}
					role="button"
					tabIndex={0}
				>
					<a
						href={props.data.path}
						className="nav_accordion-item__line"
						key={props.data.title}
					>
						<p className="nav_accordion-item__title" key={props.data.title}>
							{props.data.title}
						</p>
						{props.data.links.length ? (
							<div className="nav_accordion-item__icon">{renderIcon()}</div>
						) : null}
					</a>
					{props.data.title === "Company" && (
						<div className="nav_accordion-item__inner__company">
							<div className="nav_accordion-item__content">
								<div className="productRow">
									<div>
										{props.data.links.map((link) => {
											return createCompanyElement(link);
										})}
									</div>
								</div>
							</div>
						</div>
					)}

					{props.data.title === "Resources" &&
					(
						<div
							className="nav_accordion-item__inner__resources"
							style={{ height: "450px" }}
						>
							<div className="nav_accordion-item__content">
								<div className="productRow">
									<a
										href="/resources/"
										className="mobile-product-overview-link resource-library"
									>
										All Resources
									</a>
									<div>
										<p className="product-subtitle-accordion" key="by-type">
											Resources By Type
										</p>
										{props.data.links.map((link) => {
											return createResourceElement(link);
										})}
									</div>
								</div>
							</div>
						</div>	
					)}

                    {props.data.title === "Platform" && 
                    <>
                    <div
							className="nav_accordion-item__inner"
							style={{ height: "820px" }}
						>
							<div className="nav_accordion-item__content">
								<div className="productRow">
									<div>
										{props.data.links.map((link, index) => {
											return (
												<React.Fragment key={`link-${index}`}>
													{createLinkElement(link)}	
												</React.Fragment>
											);
										})}

										<p
											className="product-subtitle-accordion"
											style={{ marginTop: "30px" }}
										>
											Related Items
										</p>
										<div className="related-column">
											<a
												className="related-button"
												href="/whats-new/"
												style={{ paddingLeft: "20px" }}
											>
												<img
													src={WhatsNewIcon}
													alt="Orange phone icon"
													width="18"
												/>
												<p className="related-text">What's New</p>
											</a>
									
											<a className="related-button" href="/integrations/">
												<img
													src={IntegrationsIcon}
													alt="Green chain icon"
													width="21"
												/>
												<p className="related-text">Integrations</p>
											</a>
											<a className="related-button" href="/legal/security/">
												<img
													src={SecurityIcon}
													alt="Purple lock icon"
													width="19"
												/>
												<p className="related-text">Security</p>
											</a>
											<a className="related-button" href="/referral/">
												<img
													src={ReferralIcon}
													alt="Purple lock icon"
													width="19"
												/>
												<p className="related-text">Referral Program</p>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
                    </>
                    }
				</div>
			)}
		</>
	);
};

export default AccordionItem;
